import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { HTTP_SERVER_URL } from '../../configuration';

export const ModalType = 'TODAY_BOOKINGS_MODAL';

interface Booking {
  id: number;
  provider_id: string;
  realname: string;
  slot_time: string;
  help: boolean;
}

function formatTime(isoString: string): string {
  const d = new Date(isoString);
  return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
}

function getToken(): string {
  const raw = localStorage.getItem('Token');
  return raw ? JSON.parse(raw).token : '';
}

const pastStyle = { backgroundColor: '#f0f0f0', color: '#888' };

export default (props: any): JSX.Element => {
  const queueName: string = props.queueName;
  const [upcoming, setUpcoming] = useState<Booking[]>([]);
  const [past, setPast] = useState<Booking[]>([]);

  useEffect(() => {
    if (!props.show) return;
    fetch(`${HTTP_SERVER_URL}/api/queues/${queueName}/bookings`, {
      headers: { Authorization: `Token ${getToken()}` }
    })
      .then(r => r.json())
      .then((data: Booking[]) => {
        const now = new Date();
        const today = now.toDateString();
        const todayBookings = data
          .filter(b => new Date(b.slot_time).toDateString() === today)
          .sort((a, b) => a.slot_time.localeCompare(b.slot_time));
        setUpcoming(todayBookings.filter(b => new Date(b.slot_time) >= now));
        setPast(todayBookings.filter(b => new Date(b.slot_time) < now));
      })
      .catch(() => { setUpcoming([]); setPast([]); });
  }, [props.show, queueName]);

  const total = upcoming.length + past.length;

  const renderRows = (bookings: Booking[], style?: React.CSSProperties) =>
    bookings.map(b => (
      <tr key={b.id} style={style}>
        <td>{formatTime(b.slot_time)}</td>
        <td>{b.realname}</td>
      </tr>
    ));

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Today's bookings — {queueName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {total === 0
          ? <p className="text-muted">No bookings for today.</p>
          : <table className="table table-sm table-bordered mb-0">
              <thead className="thead-dark">
                <tr>
                  <th>Time</th>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {upcoming.length > 0 && (
                  <tr><td colSpan={2} className="text-muted" style={{ fontSize: '0.8em', padding: '2px 8px' }}>Upcoming ({upcoming.length})</td></tr>
                )}
                {renderRows(upcoming)}
                {past.length > 0 && (
                  <tr><td colSpan={2} className="text-muted" style={{ fontSize: '0.8em', padding: '2px 8px', ...pastStyle }}>Past ({past.length})</td></tr>
                )}
                {renderRows(past, pastStyle)}
              </tbody>
            </table>
        }
      </Modal.Body>
    </Modal>
  );
};
